export const keysByUserType = {
  admin: {
    filterKeys: [
      'owned',
      'pending',
      'delayed',
      'completed',
      'cancelled',
      'rejected',
      'rejected-tasks',
      'errored-tasks',
      'mine',
      'following',
      'paused',
      'all',
      'awaiting-receipt',
    ],
    defaultFilterKey: 'owned',
  },
  regularUser: {
    filterKeys: [
      'owned',
      'mine',
      'minePending',
      'mineDelayed',
      'mineCancelled',
      'mineCompleted',
      'minePaused',
      'following',
      'all',
      'awaiting-receipt',
    ],
    defaultFilterKey: 'mine',
  },
} as const

export const requestTopLevelFilterKeys = [...keysByUserType.admin.filterKeys, ...keysByUserType.regularUser.filterKeys] as const
export type RequestTopLevelFilterKey = (typeof requestTopLevelFilterKeys)[number]

// Tabs /paginated-v2 can serve today. `buildTopLevelFilterClause` in listRequestsPaginatedV2 keys
// its clause table on `ServerSupportedTopLevelFilterKey`, so this list and the server implementation
// can't drift — a key here without a clause (or a clause without a key) won't compile. Partial-
// pagination mode falls back to the client path for any other tab.
export const serverSupportedTopLevelFilterKeys = [
  'all',
  'mine',
  'owned',
  'pending',
  'completed',
  'rejected',
  'paused',
  'cancelled',
  'following',
  'rejected-tasks',
  'errored-tasks',
  'minePending',
  'mineCancelled',
  'mineCompleted',
  'minePaused',
] as const satisfies readonly RequestTopLevelFilterKey[]
export type ServerSupportedTopLevelFilterKey = (typeof serverSupportedTopLevelFilterKeys)[number]

export const isServerSupportedTopLevelFilterKey = (key: RequestTopLevelFilterKey): key is ServerSupportedTopLevelFilterKey =>
  serverSupportedTopLevelFilterKeys.some((k) => k === key)
